// Page Contact - Affiche les informations de contact

import React, { Component } from "react";

export default class Contact extends Component {
  render() {
    return (
      <div class="flex-grow">
        <div className="w-full max-w-screen-xl mx-auto p-4">
          <h2 class="text-2xl font-semibold mb-4">Impressum</h2>
          <h3 class="font-semibold mb-4">Responsable du contenu</h3>
          <p class="mb-4">
            Le contenu est géré par le Service de la mobilité du canton de
            Fribourg
          </p>
          <h3 class="font-semibold mb-4">Contact</h3>
          <address class="mb-4">
            <a href="mailto:bastien.chardonnens@fr.ch">Bastien Chardonnens</a>
            <br></br>
            <br></br>
            Service de la mobilité (SMo) <br></br>
            Grand-Rue 32<br></br>
            1701 Fribourg<br></br>T +41 26 304 14 33
          </address>
          <h3 class="font-semibold mb-4">Source des données</h3>
          <h3 class="font-semibold mb-4">Conditions générales</h3>
        </div>
      </div>
    );
  }
}
